import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_ERROR, AUTH_CHECK, AUTH_GET_PERMISSIONS, GET_ONE } from 'react-admin';
import dataProvider from './dataProvider';

const serverLogout = () => {
    const request = new Request(process.env.REACT_APP_AUTH_LOGOUT_ENDPOINT, {
        method: 'GET',
        mode: 'cors',
        credentials: 'include'
    });

    localStorage.removeItem('role');
    localStorage.removeItem('name');
    localStorage.removeItem('email');

    if (process.env.NODE_ENV === "development") {
        return Promise.resolve();
    }
    return fetch(request)
        .finally(() => Promise.resolve());
}

const callUserMe = () => {
    return dataProvider(GET_ONE, 'users', { id: 'me' });
}

const saveUserInfo = (json) => {
    localStorage.setItem('role', json.permission);
    localStorage.setItem('name', json.name ? json.name : "");
    localStorage.setItem('email', json.email ? json.email : "");
}

/**
 * ログイン処理を行います。初期化処理を行うため、ログインのCallback後、最初に呼ぶ必要があります。
 */
const serverLogin = () => {
    return callUserMe()
        .then(res => res.data)
        .then(json => {
            saveUserInfo(json);
        });
}

export default (type, params) => {
    // called when the user attempts to log in
    if (type === AUTH_LOGIN) {
        return serverLogin();
    }
    // called when the user clicks on the logout button
    if (type === AUTH_LOGOUT) {
        return serverLogout();
    }
    // called when the API returns an error
    if (type === AUTH_ERROR) {
        const { status } = params;
        if (status === 401 || status === 403) {
            localStorage.removeItem('role');
            return Promise.reject();
        }
        return Promise.resolve();
    }
    // called when the user navigates to a new location
    if (type === AUTH_CHECK) {
        return localStorage.getItem('role') ? Promise.resolve() : Promise.reject();
    }
    if (type === AUTH_GET_PERMISSIONS) {
        const role = localStorage.getItem('role');
        return role ? Promise.resolve(parseInt(role)) : Promise.resolve(0);
    }
    return Promise.reject('Unknown method');
};